import { observable, makeObservable } from 'mobx';

import { Account } from '@vromo/models';
import { createModelSchema, optional, object } from 'serializr';

export default class AccountStore {
    account: Account | null = null;
    loaded = false;

    constructor() {
        makeObservable(this, {
            account: observable,
            loaded: observable
        });
    }
}

createModelSchema(AccountStore, {
    account: optional(object(Account))
});
